"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isEmail_1 = __importDefault(require("validator/lib/isEmail"));
var isISO8601_1 = __importDefault(require("validator/lib/isISO8601"));
function validateIsRequired(fieldName, value) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!value) {
        addMessage(createRequiredMessage(fieldName));
    }
    return messages;
}
exports.validateIsRequired = validateIsRequired;
function validateEmail(email) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!email) {
        addMessage(createRequiredMessage("Email address"));
    }
    else if (!isEmail_1.default(email)) {
        addMessage(createInValidMessage("email address"));
    }
    return messages;
}
exports.validateEmail = validateEmail;
function validateEmailsMatch(email, confirmEmail) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    // We require something to check but we won't validate format here..
    if (!email) {
        addMessage(createRequiredMessage("Email address"));
    }
    if (!confirmEmail) {
        addMessage(createRequiredMessage("Confirm email address"));
    }
    if (messages.length === 0) {
        if (email !== confirmEmail) {
            addMessage(createMatchMessage("email addresses"));
        }
    }
    return messages;
}
exports.validateEmailsMatch = validateEmailsMatch;
function validateDateOfBirth(dateOfBirth) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!dateOfBirth) {
        addMessage(createRequiredMessage("Date of birth"));
    }
    else if (!isISO8601_1.default(dateOfBirth, { strict: true })) {
        addMessage(createInValidMessage("date of birth"));
    }
    return messages;
}
exports.validateDateOfBirth = validateDateOfBirth;
function validateSurname(lastName) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!lastName) {
        addMessage(createRequiredMessage("Last name"));
    }
    else {
        var regularExpression = useRegularExpression(/^[A-Za-zÀ-ÖØ-öø-ÿ '-]+$/);
        var resultMessage = regularExpression(lastName, createInValidMessage("last name"));
        addMessage(resultMessage);
    }
    return messages;
}
exports.validateSurname = validateSurname;
function validatePostcode(fieldName, postcode) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!postcode) {
        addMessage(createRequiredMessage("Postcode"));
    }
    else {
        var regularExpression = useRegularExpression(/^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/);
        var resultMessage = regularExpression(postcode, createInValidMessage(fieldName));
        addMessage(resultMessage);
    }
    return messages;
}
exports.validatePostcode = validatePostcode;
function validatePolicy(fieldName, postcode) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!postcode) {
        addMessage(createRequiredMessage("Policy number"));
    }
    else {
        var regularExpression = useRegularExpression(/^[a-zA-Z0-9_]*$/);
        var resultMessage = regularExpression(postcode, createInValidMessage(fieldName));
        addMessage(resultMessage);
    }
    return messages;
}
exports.validatePolicy = validatePolicy;
function validatePassword(password) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!password) {
        addMessage(createRequiredMessage("Password"));
    }
    else {
        // special characters are: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ `
        // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
        var regularExpression = useRegularExpression(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^\$\*\.\[\]\{\}\(\)\?\-\"!@#%&\/\\\,\<\>\'\:\;\|\_\~\`])(?=.{10,})/);
        var resultMessage = regularExpression(password, createInValidMessage("password"));
        if (resultMessage) {
            addMessage(resultMessage);
            addMessage("At least 10 characters.");
            addMessage("At least 1 upper case letter.");
            addMessage("At least 1 lower case letter.");
            addMessage("At least 1 special character.");
            addMessage("At least 1 number.");
        }
    }
    return messages;
}
exports.validatePassword = validatePassword;
function validatePasswordsMatch(password, confirmPassword) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!password) {
        addMessage(createRequiredMessage("Password"));
    }
    if (!confirmPassword) {
        addMessage(createRequiredMessage("Confirm password"));
    }
    if (messages.length === 0) {
        if (password !== confirmPassword) {
            addMessage(createMatchMessage("passwords"));
        }
    }
    return messages;
}
exports.validatePasswordsMatch = validatePasswordsMatch;
function validateCode(code) {
    var _a = useMessages(), messages = _a[0], addMessage = _a[1];
    if (!code) {
        addMessage(createRequiredMessage("Code"));
    }
    else {
        var regularExpression = useRegularExpression(/^[0-9]{6}$/);
        var resultMessage = regularExpression(code, createInValidMessage("code"));
        addMessage(resultMessage);
    }
    return messages;
}
exports.validateCode = validateCode;
function useMessages() {
    var messages = new Array();
    return [
        messages,
        function (message) {
            if (message) {
                messages.push(message);
            }
        }
    ];
}
function useRegularExpression(regularExpression) {
    return function (valueToTest, failureMessage) {
        var resultMessage = "";
        if (!regularExpression.test(valueToTest)) {
            resultMessage = failureMessage;
        }
        return resultMessage;
    };
}
function createRequiredMessage(fieldName) {
    return fieldName + " is a required field.";
}
function createInValidMessage(fieldName) {
    return "Please enter a valid " + fieldName + ".";
}
function createMatchMessage(fieldsDescription) {
    return "Please ensure the " + fieldsDescription + " match.";
}
